import {constants} from '@newsela/angelou';
import {css} from 'emotion';

const blue = constants.colors.status.primary['500'];
const darkBlue = constants.colors.status.primary['700'];
const white = constants.colors.ui.white['700'];

export const baseStyle = {
  border: `0.2em solid ${blue}`,
  borderRadius: '4px',
  padding: '10px 16px',
  fontFamily: 'Circular, "Segoe UI", Helvetica, Arial, sans-serif',
  cursor: 'pointer',
  whiteSpace: 'nowrap'
};

export const hollowLink = css({
  ...baseStyle,
  '&, :visited': {
    color: blue,
  },
  ':hover, :focus': {
    color: white,
    backgroundColor: blue,
  }
});

export const solidLink = css({
  ...baseStyle,
  '&, :visited': {
    backgroundColor: blue,
    color: white,
  },
  ':hover, :focus': {
    backgroundColor: darkBlue,
    borderColor: darkBlue,
    color: white,
  }
});
